import * as BizCharts from 'bizcharts';

// G2 v2 (BizCharts v3) default vivid color palette.
// G2 v4 uses more muted colors by default — this restores the original look.
const COLOR_PLATE_10 = [
	'#1890FF',
	'#2FC25B',
	'#FACC14',
	'#223273',
	'#8543E0',
	'#13C2C2',
	'#3436C7',
	'#F04864',
	'#E6965C',
	'#D598D9',
];

const COLOR_PLATE_20 = [
	'#1890FF',
	'#41D9C7',
	'#2FC25B',
	'#FACC14',
	'#E6965C',
	'#223273',
	'#7564CC',
	'#8543E0',
	'#5C8EE6',
	'#13C2C2',
	'#5CA3E6',
	'#3436C7',
	'#B381E6',
	'#F04864',
	'#D598D9',
	'#66B5FF',
	'#6EDB8F',
	'#9AE65C',
	'#57AD71',
	'#738AE6',
];

BizCharts.G2.registerTheme('openwrench', {
	styleSheet: {
		paletteQualitative10: COLOR_PLATE_10,
		paletteQualitative20: COLOR_PLATE_20,
		brandColor: '#1890FF',
	},
});
